import a from "react";
import { getIconColor as r } from "./iconfont.es5470.js";
import f from "./iconfont.es5471.js";
const m = {
  display: "block"
}, E = ({ size: t = 16, useVw: o, useRem: l, color: c, withColor: n, removeClassName: e, disableSSR: d, style: i, ...p }) => {
  const x = i ? { ...m, ...i } : m;
  return /* @__PURE__ */ a.createElement(f, { disableSSR: d }, /* @__PURE__ */ a.createElement("svg", { "data-icon-id": "32px-jiaoyi", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: o ? ((t || 0) / 375 * 100).toFixed(5) + "vw" : t + (l ? "rem" : "px"), height: o ? ((t || 0) / 375 * 100).toFixed(5) + "vw" : t + (l ? "rem" : "px"), className: e ? "" : "iconpark-icon", style: x, fill: "none", ...p }, /* @__PURE__ */ a.createElement(
    "g",
    {
      className: e ? "" : "32px-äº¤æ"
    },
    /* @__PURE__ */ a.createElement(
      "g",
      {
        className: e ? "" : "normal",
        fill: n ? r(c, 0, "#262933") : "#262933",
        datafollowfill: n ? r(c, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M16 27.1c6.13 0 11.1-4.97 11.1-11.1 0-2.023-.54-3.918-1.484-5.55a.9.9 0 1 1 1.558-.9A12.845 12.845 0 0 1 28.9 16c0 7.125-5.775 12.9-12.9 12.9-7.124 0-12.9-5.775-12.9-12.9C3.1 8.876 8.876 3.1 16 3.1c2.494 0 4.825.709 6.8 1.936a.9.9 0 1 1-.95 1.529A11.044 11.044 0 0 0 16 4.9C9.87 4.9 4.9 9.87 4.9 16S9.87 27.1 16 27.1Z"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M18.729 11.164a.9.9 0 0 1-.214.943l-7.306 7.227a.9.9 0 0 1-1.266-1.28l5.932-5.867-2.713-.25a.9.9 0 0 1 .165-1.792l4.637.426a.9.9 0 0 1 .765.593Zm-5.506 9.676a.9.9 0 0 0 .55 1.536l4.638.426a.9.9 0 1 0 .165-1.793l-2.713-.249 5.932-5.867a.9.9 0 0 0-1.266-1.28l-7.306 7.227Z"
        }
      )
    )
  )));
}, h = E;
export {
  h as default
};
